module.exports = __webpack_public_path__ + "img/lk.lk25692a4.svg";